export var getActionDescriptor = function (type, properties) {
    return "".concat(type).concat((properties === null || properties === void 0 ? void 0 : properties.status) ? " ".concat(properties === null || properties === void 0 ? void 0 : properties.status) : "");
};
//# sourceMappingURL=base.js.map